import { useEffect, useState } from "react";
import useDelayUnmount from "../../../hooks/useDelayUnmount";
import classes from "./ScratchSimpleSelectOption.module.css";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ValidationErrors from "../ValidationErrors/ValidationErrors";
import useFormFieldAccess from "../../../hooks/useFormFieldAccess";
import ClearIcon from "@mui/icons-material/Clear";
import { ReactComponent as ArrowDown } from "../../../images/icons/forms/arrowSquareDown.svg";
import MultiLanTxt from "../MultiLanTxt/MultiLanTxt";

const ScratchSimpleSelectOption = ({
  name,
  edit,
  value,
  options,
  onChange,
  disabled,
  label,
  validityName,
  optionPreferedKey,
  uniqueLabelId,
  fieldAccesses = [],
  fieldNames = [],
  style,
  deletable,
  valueType,
  forceLtr,
  isMandatory,
  currentState = "unset",
  disableStateCanEditThisField,
  beforeOpenOptionsFunc,
  forcePe,
}) => {
  const [open, setOpen] = useState(false);
  const showOptions = useDelayUnmount(open, 250);
  const [focusOn, setFocusOn] = useState(0);
  const disableForAccess = useFormFieldAccess(
    fieldAccesses,
    fieldNames,
    currentState,
    disableStateCanEditThisField
  );

  useEffect(() => {
    if (edit && options.length > 0 && value) {
      let foundOptiondIndex = options.findIndex((op) => {
        if (typeof op === "object") {
          return op?.id === value?.id;
        } else {
          return op === value;
        }
      });
      setFocusOn(foundOptiondIndex ? foundOptiondIndex : 0);
    }
  }, [options, value]);

  const optionClickHandler = (option, index) => {
    let preferedObj = { target: { value: option, name } };
    onChange(preferedObj);
    setFocusOn(index);
    setOpen(false);
  };
  const renderProperTxt = (option) => {
    let returnedVal;
    if (typeof option === "string" || typeof option === "number") {
      returnedVal = option;
    } else {
      if (optionPreferedKey) {
        returnedVal = option?.[optionPreferedKey];
      } else {
        returnedVal = option?.name
          ? option.name
          : option?.title
          ? option.title
          : //  "which key should be shown";
            "";
      }
    }

    return returnedVal;
  };
  const renderProperTxtFromOptions = (option) => {
    let foundedOption = options.find((which) => which.value === option);
    let properTxt = foundedOption?.name;
    return properTxt;
  };
  const openOptionsHandler = () => {
    if (beforeOpenOptionsFunc) beforeOpenOptionsFunc();
    setOpen(true);
  };
  const blurOnTabClick = (e) => {
    if (e.key === "Tab") {
      setOpen(false);
    }
  };

  return (
    <>
      {open ? <div className={classes.bckdrp} onClick={(e) => setOpen(false)} /> : null}
      <div
        className={[classes.container, style === "tableSearch" ? classes.fullHeight : null].join(" ")}
      >
        <span
          className={[
            classes.labelsContainer,
            disabled || disableForAccess
              ? [classes.disabledCursor, "disabledinputPLabel"].join(" ")
              : open
              ? "focusedinputPLabel"
              : validityName
              ? validityName?.isValid
                ? "enabledinputPLabel"
                : "invalidinputPLabel"
              : "enabledinputPLabel",
          ].join(" ")}
          onClick={(e) => (!disabled && !disableForAccess ? openOptionsHandler() : null)}
        >
          <label
            className={[
              classes.label,
              value
                ? [classes.labelUp, "pLabelUp"].join(" ")
                : [classes.labelDown, "pLabelDown"].join(" "),
            ].join(" ")}
            htmlFor={uniqueLabelId ? uniqueLabelId : name}
            onClick={(e) => (!disabled && !disableForAccess ? openOptionsHandler() : null)}
          >
            {label}
            {isMandatory ? <span className={classes.mandatorySign}>*</span> : null}
          </label>
          {/* {style !== "tableSearch" || (style === "tableSearch" && !value) ? (
            <label
              className={[
                style === "tableSearch" ? classes.tableSearchArrowLabel : classes.arrowLabel,
                open ? classes.reversedIcon : null,
              ].join(" ")}
              htmlFor={uniqueLabelId ? uniqueLabelId : name}
            >
              <ArrowDown />
            </label>
          ) : (
            <label
              className={[
                style === "tableSearch" ? classes.tableSearchArrowLabel : classes.arrowLabel,
                open ? classes.reversedIcon : null,
              ].join(" ")}
              htmlFor={uniqueLabelId ? uniqueLabelId : name}
              onClick={clearValueHandler}
            >
              <ClearIcon />
            </label>
          )} */}
          {!disabled && !disableForAccess ? (
            deletable && value ? (
              <label
                className={[
                  style === "tableSearch"
                    ? [classes.tableSearchArrowLabel, "disabledinputPLabel"].join(" ")
                    : [
                        classes.arrowLabel,
                        disabled || disableForAccess
                          ? "disabledinputPLabel"
                          : open
                          ? "focusedinputPLabel"
                          : validityName?.isValid === false
                          ? "invalidinputPLabel"
                          : "enabledinputPLabel",
                      ].join(" "),
                  open ? classes.reversedIcon : null,
                ].join(" ")}
                htmlFor={uniqueLabelId ? uniqueLabelId : name}
                onClick={(e) => {
                  let preferedObj = { target: { value: null, name } };
                  e.stopPropagation();
                  onChange(preferedObj);
                }}
              >
                <ClearIcon />
              </label>
            ) : (
              <label
                className={[
                  style === "tableSearch"
                    ? [classes.tableSearchArrowLabel, "disabledinputPLabel"].join(" ")
                    : [
                        classes.arrowLabel,
                        disabled || disableForAccess
                          ? "disabledinputPLabel"
                          : open
                          ? "focusedinputPLabel"
                          : validityName?.isValid === false
                          ? "invalidinputPLabel"
                          : "enabledinputPLabel",
                      ].join(" "),
                  open ? classes.reversedIcon : null,
                ].join(" ")}
                htmlFor={uniqueLabelId ? uniqueLabelId : name}
              >
                <ArrowDown />
              </label>
            )
          ) : null}
        </span>
        <p
          id={uniqueLabelId ? uniqueLabelId : name}
          className={[
            "pInput",
            style === "tableSearch" ? classes.tableSearchSelectInput : classes.selectInput,
            style === "tableSearch"
              ? null
              : disabled || disableForAccess
              ? ["disabledPInput", classes.autoCursor].join(" ")
              : open
              ? "focusedPInput"
              : validityName
              ? validityName?.isValid
                ? "enabledPInput"
                : "invalidPInput"
              : "enabledPInput",
          ].join(" ")}
        >
          {style === "tableSearch" ? (
            value === "" || value === null ? (
              <span className="pLabelPlaceholder">{forceLtr ? "Search" : "جست و جو"}</span>
            ) : valueType === "boolean" ? (
              renderProperTxtFromOptions(value)
            ) : (
              renderProperTxt(value)
            )
          ) : (
            <span className={classes.finalValue}> {renderProperTxt(value)}</span>
          )}
        </p>
        {showOptions ? (
          <div
            className={[classes.optionsContainer, open ? classes.mounted : classes.unmounted].join(" ")}
          >
            {options?.length ? (
              <>
                {options?.map((option, index) => (
                  <p
                    key={index}
                    className={[
                      "pLabelUp",
                      "enabledinputPLabel",
                      style === "tableSearch" ? classes.tableSearchOptionInput : classes.optionInput,
                      focusOn === index && value ? classes.focusedOption : null,
                    ].join(" ")}
                    onClick={(e) => optionClickHandler(option, index)}
                  >
                    {renderProperTxt(option)}
                  </p>
                ))}
              </>
            ) : (
              <p className={classes.optionInput}>
                {forceLtr ? (
                  "No option"
                ) : forcePe ? (
                  " گزینه ای یافت نشد "
                ) : (
                  <MultiLanTxt tid="NO_OPTION" />
                )}
              </p>
            )}
          </div>
        ) : null}
        <input
          className={classes.hiddenInput}
          onFocus={(e) => (!disabled && !disableForAccess ? openOptionsHandler() : null)}
          onKeyDown={blurOnTabClick}
          disabled={disabled || disableForAccess}
        />
        {validityName ? (
          <ValidationErrors validity={validityName?.isValid} message={validityName?.msg} />
        ) : null}
      </div>
    </>
  );
};

export default ScratchSimpleSelectOption;
